<template>
  <div id="app" style="height: 100%" @click="isTimeOut">
    <router-view />
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "App",
  data (){
    return {
      lastTime: null, //最后一次点击时间
      currentTime: null, //当前点击时间
      timeOut: 30*60*1000 //设置超时时间
    }
  },
  created() {
    this.lastTime = new Date().getTime()
  },
  methods: {
    isTimeOut(){
      this.currentTime = new Date().getTime() //记录这次点击的时间
      if (this.currentTime - this.lastTime > this.timeOut){
        if (localStorage.getItem("loginInfo")){ //如果是登录状态
          localStorage.clear()
          sessionStorage.clear();
          this.$alert('长时间未操作！请退出重新登录', '登录超时提醒', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push({ path: '/login'})
            }
          })
        }else {
          this.lastTime = new Date().getTime()
        }
      } else {
        this.lastTime = new Date().getTime()
      }
    }
  }
};
</script>

<style>
::-webkit-scrollbar-track{
  background:rgba(0,0,0,.1);
  border-radius:0;
}
::-webkit-scrollbar{
  -webkit-appearance:none;
  width:4px;
  height:4px;
}
::-webkit-scrollbar-thumb{
  cursor:pointer;
  border-radius: 2px;
  background:rgba(0,0,0,.15);
  transition: color .2s ease;
}
</style>
